import { UserType } from '../models/user.model';

export function translateErrorMessage(errorMessage: string): string {
  switch (errorMessage) {
    case 'Email already verified':
      return 'Die E-Mail wurde bereits verifiziert!';
    case 'Email verification failed':
      return 'Die E-Mail konnte nicht verifiziert werden!';
    case 'Registration failed':
      return 'Die Registrierung ist fehlgeschlagen!';
    case 'Login failed':
      return 'Die Anmeldung ist fehlgeschlagen!';
    case 'Invalid credentials':
      return 'Benutzername oder Passwort sind ungültig!';
    case 'Password reset failed':
      return 'Das Zurücksetzen des Passworts ist fehlgeschlagen!';
    case 'Sending password reset failed':
      return 'Das Senden der Passwort-Reset E-Mail ist fehlgeschlagen!';
    case 'No user with this email not found':
      return 'Kein Benutzer mit dieser E-Mail gefunden!';
    case 'Invalid token':
      return 'Der Passwort Reset Link ist ungültig!';
    default:
      return 'Ein unbekannter Fehler ist aufgetreten!';
  }
}

export const de = {
  firstDayOfWeek: 1,
  dayNames: [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
  ],
  dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  monthNames: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mär',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],
  today: 'Heute',
  clear: 'Löschen',
};

export function translateUserType(userType: UserType): string {
  switch (userType) {
    case UserType.USER:
      return 'Nutzer';
    case UserType.LECTURER:
      return 'Dozent';
    case UserType.COOPERATION:
      return 'Kooperation';
    default:
      return 'Benutzer';
  }
}
